// removed by extract-text-webpack-plugin
module.exports = {"appStrategyContainer":"_3JNKu1eI-K0XglaR3k_ZHw","titleContainer":"_2tzjOKrkLPy5MdLqEcElLD","paginContaoner":"_1BihKkR5SPWKlNyiSqVPwp"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/AppStrategy/AppStrategy.less
// module id = 1625
// module chunks = 0